import {useEffect, useState} from 'react';
import {checkIsAdminPage, isNeedGoToLogin} from 'utils/functions';
import {Store} from 'utils/mobx';
import {useNavigate} from "react-router-dom";
import {ROUTER_PATH_LOGIN} from "utils/constantsApp";
interface UseRouterChangeInterface {
    locationPath: string,
    path: string
    businessId?: string
}

interface UseRouterChangeReturnInterface {
    isAdminPage: boolean
}

const useRouterChange: (props: UseRouterChangeInterface) => UseRouterChangeReturnInterface = (props): UseRouterChangeReturnInterface => {
    const {
        locationPath = '',
        path = '',
        businessId = ''
    } = props
    const {RouterStore, AdminSiderStore} = Store
    const navigate = useNavigate();
    const {
        setPath,
        setLastPath
    } = RouterStore
    const [isAdminPage, setIsAdminPage] = useState<boolean>(false)
    useEffect(():void => {
        const pathname: string = locationPath
        const isNeedToLogin = isNeedGoToLogin(pathname)
        // const loginRequest = {
        //     url: path,
        //     auth: ''
        // }
        // const fomartSearchToString = urlSearchToString(loginRequest)
        if (isNeedToLogin) {
            setLastPath(path)
            // setPath(`${ROUTER_PATH_LOGIN}`)
            navigate(ROUTER_PATH_LOGIN)
        }
        const isInternal: boolean = checkIsAdminPage(pathname, businessId)
        setIsAdminPage(isInternal)
    }, [locationPath])

    useEffect(() => {
        const appUrl: string = path;
        const windowUrl = window.location.pathname
        if (appUrl !== windowUrl) {
            navigate(appUrl)
        }
    }, [path]);

    useEffect(() => {
        if (isAdminPage && !AdminSiderStore.adminSiderMenuList) {
            AdminSiderStore.getAdminSiderStore()
        }
    }, [isAdminPage, AdminSiderStore.adminSiderMenuList]);

    return { isAdminPage };
};

export default useRouterChange;